import {
  GIFTCARD_BALANCE_ERROR,
  GIFTCARD_BALANCE_LOADING,
  GIFTCARD_BALANCE_SUCESS,
  GIFTCARD_BALANCE_RESET,
} from '../types/GiftCardTypes';

const initialState = {
  balance: {},
  status: 'idle',
  errorStatus: '',
};

const giftCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GIFTCARD_BALANCE_LOADING:
      return { ...state, status: 'loading' };
    case GIFTCARD_BALANCE_ERROR:
      return {
        ...state,
        status: 'error',
        errorStatus: action.status ? action.status : '',
      };
    case GIFTCARD_BALANCE_SUCESS:
      return { ...state, status: 'succeded', balance: action.balance };
    case GIFTCARD_BALANCE_RESET:
      return initialState;
    default:
      return state;
  }
};

export default giftCardReducer;
